<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>学校管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="goToAdd"
    >新增学校</el-button>
    <el-table
      :data="schoolList"
      style="width: 100%">
      <el-table-column
        prop="schoolNo"
        label="学校编码"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="schoolName"
        label="学校名称"
        align="center">
      </el-table-column>
      <el-table-column
        prop="typeDesc"
        label="学校类别"
        align="center">
      </el-table-column>
      <el-table-column
        prop="admins"
        label="管理员：管理员手机号"
        align="center">
        <template slot-scope="scope">
          <div v-for="(v, k) in scope.row.admins" :key="k">{{v.adminName}}：{{v.adminPhoneNo}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '@/common/js/config';
  import { getSchoolList } from '@/api/school';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'school_list',
    data() {
      return {
      };
    },
    created() {
      this._getSchoolList();
    },
    methods: {
      goToAdd(item = {}) {
        this.setItem({
          item,
          type: listType.SCHOOL
        });
        this.$router.push('/add_school');
      },
      handleEdit(index, item) {
        this.setItem({
          item,
          type: listType.SCHOOL
        });
        this.$router.push({
          path: `/update_school/${item.uuid}`
        });
      },
      _getSchoolList() {
        getSchoolList(this.user.userId).then((res) => {
          this.setList({
            list: res.schools,
            type: listType.SCHOOL
          });
        });
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'schoolList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .add-btn
      margin-bottom: 20px;
</style>